// Enums for type safety (matching server)
export enum CardColor {
  RED = "red",
  BLUE = "blue",
  GREEN = "green",
  YELLOW = "yellow",
  WILD = "wild",
}

export enum CardValue {
  SKIP = "skip",
  REVERSE = "reverse",
  DRAW2 = "draw2",
  WILD = "wild",
  WILD4 = "wild4",
}

export enum GameDirection {
  CLOCKWISE = "clockwise",
  COUNTERCLOCKWISE = "counterclockwise",
}

export enum GameStatus {
  WAITING = "waiting",
  PLAYING = "playing",
  FINISHED = "finished",
}

// Discriminated union for card values
export type CardValueType = number | CardValue;

// Card interface
export interface Card {
  color: CardColor;
  value: CardValueType;
}

// Player interface
export interface Player {
  id: string;
  name: string;
  cardsCount: number;
  hasSaidUNO: boolean;
}

// Non-wild color type
export type NonWildColor = Exclude<CardColor, CardColor.WILD>;

// Game state (read-only from server)
export interface GameState {
  readonly roomId: string;
  readonly players: readonly Player[];
  readonly hands: Readonly<Record<string, readonly Card[]>>;
  readonly deck: readonly Card[];
  readonly discardPile: readonly Card[];
  readonly currentTurnPlayerId: string;
  readonly direction: GameDirection;
  readonly currentColor: NonWildColor;
  readonly pendingDraw: number;
  readonly status: GameStatus;
  readonly winnerId?: string;
}

// Play card request
export interface PlayCardRequest {
  readonly cardIndex: number;
  readonly chosenColor?: NonWildColor;
}
